module.exports = __webpack_public_path__ + "img/rose.d8b186e6.png";